import { MOBILE_SCREEN_WIDTH_BREAKPOINT } from "./constants";
import React from "react";
import { styled } from "styled-components";

const Scale = ({ highLabel, lowLabel, percentage }) => {
  return (
    <>
      <Line />
      <Labels>
        <p>{lowLabel}</p>
        <p>{highLabel}</p>
        <Circle $percentage={percentage} />
      </Labels>
    </>
  );
};

export default Scale;

const Line = styled.div`
  margin-top: 40px;
  width: 100%;
  height: 0;
  border: 1px solid #000;
  @media only screen and (max-width: ${MOBILE_SCREEN_WIDTH_BREAKPOINT}px) {
    margin-top: 32px;
  }
`;

const Labels = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #000;
  font-weight: 500;
  font-size: 20px;
  line-height: 0;

  @media only screen and (max-width: ${MOBILE_SCREEN_WIDTH_BREAKPOINT}px) {
    font-size: 16px;
  }
`;

const Circle = styled.div`
  position: absolute;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: solid 2px #000;
  left: ${(options) => options.$percentage}%;
  transform: translate(0, -10px);
`;
